module.exports = __webpack_public_path__ + "img/Imagen 2.d0af801e.png";